"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useAcceptStrToMap = function (accept) {
    if (accept === void 0) { accept = ''; }
    var acceptMap = (0, react_1.useMemo)(function () { return (accept
        .split(',')
        .reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[item.trim().toLowerCase()] = true, _a)));
    }, {})); }, [accept]);
    return acceptMap;
};
exports.default = useAcceptStrToMap;
